export default "__VITE_ASSET__8QTE6PEr__"